import { CommonModule } from '@angular/common';
import {LoginComponent} from '../components/login/login.component';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
    ],
  declarations: [
    LoginComponent,
  ],
})
export class AuthenticationModule { }



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Authentication/authentication-module/authentication.module.ts